import ReactDOM from 'react-dom';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// project imports
import * as serviceWorker from 'serviceWorker';
import App from 'App';
import { store } from 'store';

// style + assets
import 'assets/scss/style.scss';
import storeRna from './redux/storeRna';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const redirectPath = new URLSearchParams(window.location.search).get('redirect');

if (redirectPath) {
    window.history.replaceState(null, '', redirectPath);
}
// ==============================|| REACT DOM RENDER  ||============================== //

ReactDOM.render(
    <>
        <Provider store={storeRna}>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <Provider store={store}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </Provider>
        </Provider>
    </>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
